import React, { Component, Suspense } from 'react'
import {BrowserRouter, HashRouter, Route, Routes, Navigate} from 'react-router-dom'
import './scss/style.scss'
import { isAuthenticated } from './services/userService.js'
import { isAdminAuthenticated } from './services/adminAuthService.js'
import AuthErrorToaster from './components/AuthErrorToaster'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

export function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  return children
}

// Login/permissão separados do ProtectedRoute acima (Firebase Auth) — login de
// admin hardcoded, só pra tela de pré-cadastros, enquanto não existe
// permissionamento de admin de verdade no banco.
export function AdminProtectedRoute({ children }) {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace />
  }

  return children
}

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const AdminLogin = React.lazy(() => import('./views/admin/AdminLogin'))
const PreRegistrationList = React.lazy(() => import('./views/admin/PreRegistrationList'))

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <AuthErrorToaster />
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route exact path="/admin/login" name="Admin Login" element={<AdminLogin />} />
            <Route
              exact
              path="/admin/pre-cadastros"
              name="Pré-cadastros"
              element={
                <AdminProtectedRoute>
                  <PreRegistrationList />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="*"
              name="Home"
              element={
                <ProtectedRoute>
                  <DefaultLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

export default App
